"use client";

import AppImage from "@/components/ui/AppImage";
import { useLanguage } from "@/context/LanguageContext";

export default function AboutSection() {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-20 md:py-32 bg-card">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="reveal will-animate">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <AppImage
                src="https://img.rocket.new/generatedImages/rocket_gen_img_15b8e28b2-1764669719811.png"
                alt="Tunisian artisan weaving traditional carpet on wooden loom in workshop"
                className="w-full h-[500px] object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-secondary/60 to-transparent"></div>
            </div>
          </div>

          {/* Content */}
          <div className="reveal will-animate">
            <span className="text-primary font-semibold text-sm uppercase tracking-wider">
              {t("about_badge")}
            </span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground mt-4 mb-6">
              {t("about_title")}
            </h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p>{t("about_p1")}</p>
              <p>
                {t("about_p2_start")}
                <span className="font-semibold text-foreground">{t("about_p2_bold")}</span>
                {t("about_p2_end")}
              </p>
              <p className="text-foreground font-semibold">{t("about_p3")}</p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-8">
              <div>
                <div className="text-3xl font-bold text-primary">{t("about_stat1_num")}</div>
                <div className="text-sm text-muted-foreground">{t("about_stat1_label")}</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-secondary">{t("about_stat2_num")}</div>
                <div className="text-sm text-muted-foreground">{t("about_stat2_label")}</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-accent">{t("about_stat3_num")}</div>
                <div className="text-sm text-muted-foreground">{t("about_stat3_label")}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}